var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExplosion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 40.3274L31.6549 36.6726H36.6726V31.6549L40.3274 28L36.6726 24.3451V19.3274H31.6549L28 15.6726L24.3451 19.3274H19.3274V24.3451L15.6726 28L19.3274 31.6549V36.6726H24.3451L28 40.3274ZM28 56L19.6991 47.823H8.17699V36.3009L0 28L8.17699 19.6991V8.17699H19.6991L28 0L36.3009 8.17699H47.823V19.6991L56 28L47.823 36.3009V47.823H36.3009L28 56ZM28 49.0619L34.1947 42.8673H42.8673V34.1947L49.0619 28L42.8673 21.8053V13.1327H34.1947L28 6.93805L21.8053 13.1327H13.1327V21.8053L6.93805 28L13.1327 34.1947V42.8673H21.8053L28 49.0619Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplosion);
export default __webpack_public_path__ + "static/media/explosion.c783852c8e8568f239e3472e7cad23de.svg";
export { ForwardRef as ReactComponent };